import type { Product } from "@jti/magento";
import { getSessionStorage } from "@jti/rest-api";
import { CheckoutV2LoyaltyChoice } from "@jti/store/slices/checkoutV2Slice";

import type { UserSelection } from "../..";

export const LOYALTY_CHOICE_STORAGE_KEY = "loyaltyChoice";
export const LOYALTY_CART_POINTS_STORAGE_KEY = "loyaltyCartPoints";

export const updateLoyaltyUserSelection = (choice: CheckoutV2LoyaltyChoice, cartId: string): void => {
  getSessionStorage().set(LOYALTY_CHOICE_STORAGE_KEY, {
    loyaltyChoice: choice,
    cartId,
  });
};

export const getLoyaltyUserSelection = (): UserSelection => {
  return getSessionStorage().get(LOYALTY_CHOICE_STORAGE_KEY, {
    loyaltyChoice: CheckoutV2LoyaltyChoice.COLLECT,
    cartId: "",
  });
};

export const setLoyaltyCartPoints = (
  cartItems: Product[],
  loyaltyChoiceValue: CheckoutV2LoyaltyChoice,
  cartPoints: number
): void => {
  if (!cartItems?.length) {
    return;
  }

  const loyaltyCartPoints = loyaltyChoiceValue === CheckoutV2LoyaltyChoice.REDEEM ? 0 : cartPoints;
  getSessionStorage().set(LOYALTY_CART_POINTS_STORAGE_KEY, loyaltyCartPoints);
};
